'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /Users/charles/Projects/codemix/2016/flow-runtime/~/react/react.js
// module id = 1
// module chunks = 0